import React from 'react';
import Shimmer from '../../../../common/Shimmer/Shimmer';
import {CommEarningLft, CommEarningRht} from './CommissionEarning.styles';

const CommissionEarningLoader = () => {
  return (
    <React.Fragment>
      <CommEarningLft>
        <div>
          <Shimmer width={'300px'} height={'22px'} marginBottom="8px" />
        </div>
        <div>
          <Shimmer width={'153px'} height={'40px'} marginBottom="8px" />
        </div>
        <div>
          <Shimmer width={'510px'} height={'11px'} />
        </div>
      </CommEarningLft>
      <CommEarningRht>
        <Shimmer width={'204px'} height={'44px'} />
      </CommEarningRht>
    </React.Fragment>
  );
};

export default CommissionEarningLoader;
